import React, { useEffect, useState } from "react";
import { FiEdit2, FiPlus, FiTrash2, FiX, FiSave } from "react-icons/fi";
import { supabase } from "../supabaseClient";

function AboutOne() {
  const [features, setFeatures] = useState([]);
  const [modal, setModal] = useState(null);
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [iconName, setIconName] = useState("");

  useEffect(() => {
    const getFeatures = async () => {
      const res = await supabase.from("AboutOne").select("*");
      setFeatures(res.data);
    };
    getFeatures();
  }, []);

  const openCreate = () => {
    setTitle("");
    setDesc("");
    setIconName("");
    setModal({ mode: "create" });
  };

  const openEdit = (f) => {
    setTitle(f.title);
    setDesc(f.description);
    setIconName(f.icon_name ?? "");
    setModal({ mode: "edit", id: f.id });
  };

  const saveFeature = async () => {
    if (!title.trim()) return;
    if (modal.mode === "create") {
      const res = await supabase
        .from("AboutOne")
        .insert([{ title: title.trim(), description: desc.trim(), icon_name: iconName.trim() || null }])
        .select();
      setFeatures((prev) => [...prev, res.data[0]]);
    } else {
      await supabase
        .from("AboutOne")
        .update({ title: title.trim(), description: desc.trim(), icon_name: iconName.trim() || null })
        .eq("id", modal.id);
      setFeatures((prev) =>
        prev.map((f) =>
          f.id === modal.id
            ? { ...f, title: title.trim(), description: desc.trim(), icon_name: iconName.trim() || null }
            : f
        )
      );
    }
    setModal(null);
  };

  const deleteFeature = async (id) => {
    await supabase.from("AboutOne").delete().eq("id", id);
    setFeatures((prev) => prev.filter((f) => f.id !== id));
  };

  return (
    <section className="about-card">
      <div className="about-card__head">
        <h2 className="about-card__title">Feature Cards</h2>
        <button type="button" className="about-btn" onClick={openCreate}>
          <FiPlus aria-hidden />
          Add Feature
        </button>
      </div>
      <div className="about-feature-grid">
        {features.map((f) => (
          <article key={f.id} className="about-feature">
            <div className="about-feature__icon" aria-hidden>
              {f.icon_name}
            </div>
            <div className="about-feature__body">
              <h3 className="about-feature__name">{f.title}</h3>
              <p className="about-feature__desc">{f.description}</p>
            </div>
            <div className="about-icon-actions">
              <button
                type="button"
                className="about-icon-btn about-icon-btn--edit"
                aria-label={`Edit ${f.title}`}
                onClick={() => openEdit(f)}
              >
                <FiEdit2 />
              </button>
              <button
                type="button"
                className="about-icon-btn about-icon-btn--del"
                aria-label={`Delete ${f.title}`}
                onClick={() => deleteFeature(f.id)}
              >
                <FiTrash2 />
              </button>
            </div>
          </article>
        ))}
      </div>

      {modal && (
        <div className="faqs-modal-backdrop" role="presentation" onClick={() => setModal(null)}>
          <div className="faqs-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <div className="faqs-modal__head">
              <h2 className="faqs-modal__title">{modal.mode === "create" ? "Add Feature" : "Edit Feature"}</h2>
              <button type="button" className="faqs-icon-btn" onClick={() => setModal(null)} aria-label="Close">
                <FiX />
              </button>
            </div>
            <div className="faqs-modal__form">
              <label className="faqs-field">
                <span className="faqs-field__label">Title</span>
                <input className="faqs-field__input" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Feature title" autoFocus />
              </label>
              <label className="faqs-field">
                <span className="faqs-field__label">Description</span>
                <textarea className="faqs-field__textarea" value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="Feature description" rows={3} />
              </label>
              <label className="faqs-field">
                <span className="faqs-field__label">Icon name</span>
                <input className="faqs-field__input" value={iconName} onChange={(e) => setIconName(e.target.value)} placeholder="e.g. star, chat-bubble" />
              </label>
              <div className="faqs-modal__foot">
                <button type="button" className="faqs-btn faqs-btn--outline" onClick={() => setModal(null)}>Cancel</button>
                <button type="button" className="faqs-btn faqs-btn--primary" onClick={saveFeature}>
                  <FiSave aria-hidden /> Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default AboutOne;